import { Type } from '@sinclair/typebox';
import { Currencies } from '@stickerapp-org/nomisma';
//import { FamilyNameSchema, ProductNameSchema, AttributesSchema } from '../dist/esm';
import { shippingOptionsList } from "./shipping.mjs";
import { ProductItemSchema } from "./shared.mjs";
// TODO: Fix this
const FamilyNameSchema = Type.Unknown();
const ProductNameSchema = Type.Unknown();
const AttributesSchema = Type.Unknown();
export const PriceSchema = Type.Object({
    total: Type.Number(),
    breakdown: Type.Optional(Type.Record(Type.String(), Type.Number())),
    currency: Type.Enum(Currencies),
});
export const FormattedPriceSchema = Type.Composite([
    PriceSchema,
    Type.Object({
        totalFormatted: Type.String(),
        breakdownFormatted: Type.Optional(Type.Record(Type.String(), Type.String())),
    }),
]);
export const PriceDTOSchema = Type.Object({
    price: PriceSchema,
    unitPrice: Type.Number(),
    quantity: Type.Number(),
});
export const PriceListSchema = Type.Array(PriceDTOSchema);
export const FormattedPriceStepSchema = Type.Object({
    price: FormattedPriceSchema,
    unitPrice: Type.Number(),
    quantity: Type.Number(),
});
export const FormattedPriceListSchema = Type.Array(FormattedPriceStepSchema);
export const DiscountValidationSchema = Type.Object({
    language: Type.String(),
    userId: Type.Optional(Type.Number()),
    discountCode: Type.String(),
    currency: Type.Enum(Currencies),
    lines: Type.Array(Type.Object({
        id: Type.String(),
        quantity: Type.Number(),
        content: Type.Object({
            productFamilyName: Type.String(),
            productName: Type.String(),
            attributes: Type.Record(Type.String(), Type.Unknown()),
        }),
    })),
});
export const DiscountValidationResponseSchema = Type.Object({
    valid: Type.Boolean(),
    message: Type.Optional(Type.String()),
});
export const PriceQuerySchema = Type.Object({
    attributes: Type.String(),
    lang: Type.String(),
    incVat: Type.Boolean({ default: true }),
    useNewCurves: Type.Optional(Type.Boolean({ default: false })),
});
export const GetPricesResponseSchema = Type.Object({
    price: FormattedPriceSchema,
    unitPrice: Type.Number(),
    unitPriceFormatted: Type.String(),
    quantity: Type.Number(),
});
export const GetPriceListResponseSchema = Type.Object({
    prices: FormattedPriceListSchema,
});
export const PostBulkPricesRequestSchema = Type.Object({
    items: Type.Array(ProductItemSchema),
    lang: Type.String(),
    incVat: Type.Boolean({ default: true }),
});
export const PostBulkPricesResponseSchema = Type.Object({
    discount: Type.Number(),
});
export const CartItemSchema = Type.Object({
    id: Type.String(),
    productFamilyName: FamilyNameSchema,
    productName: ProductNameSchema,
    attributes: AttributesSchema,
    quantity: Type.Number({ minimum: 1 }),
});
const TaxesSchema = Type.Union([
    Type.Object({
        taxPercentage: Type.Number(),
    }),
    Type.Object({
        salesTax: Type.Object({
            base: Type.Number(),
            handling: Type.Number(),
            delivery: Type.Number(),
        }),
    }),
]);
export const PostCartSchema = Type.Object({
    language: Type.String(),
    site: Type.String(),
    isCompany: Type.Boolean(),
    address: Type.Object({
        countryCode: Type.String(),
        stateOrCounty: Type.Optional(Type.String()),
    }),
    taxes: TaxesSchema,
    userId: Type.Optional(Type.Number()),
    currency: Type.Enum(Currencies),
    discountCode: Type.Optional(Type.String()),
    lines: Type.Array(Type.Object({
        id: Type.String(),
        quantity: Type.Number(),
        content: Type.Object({
            productFamilyName: Type.String(),
            productName: Type.String(),
            attributes: Type.Record(Type.String(), Type.Unknown()),
        }),
    })),
});
const Price = Type.Object({
    amountInclTax: Type.Number(),
    amountExclTax: Type.Number(),
    taxPercentage: Type.Number(),
});
export const CartResponseSchema = Type.Object({
    itemPrices: Type.Array(Type.Object({
        id: Type.String(),
        belongsTo: Type.Unknown(),
        price: Price,
        originalPrice: Type.Optional(Price),
        bundleSavings: Type.Number(),
    })),
    bundleSavings: Type.Number(),
    discount: Type.Optional(Type.Object({
        amountInclTax: Type.Number(),
        valid: Type.Boolean(),
        message: Type.Optional(Type.String()),
    })),
    // salesTaxAmount: Type.Number(),
    total: Price,
    totalOriginal: Price,
    shippingOptions: shippingOptionsList,
});
//# sourceMappingURL=prices.js.map